import { Sparkles } from "lucide-react";

interface ChatEmptyStateProps {
  onSendMessage: (content: string) => void;
}

const SUGGESTED_QUESTIONS = [
  "What sport types are in this collection?",
  "Show me all public locations",
  "Which locations have low confidence?",
  "Summarize this collection",
];

export function ChatEmptyState({ onSendMessage }: ChatEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 px-4">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Sparkles className="h-5 w-5" />
        <span className="text-sm font-medium">AI Chat</span>
      </div>
      <p className="text-xs text-muted-foreground text-center">
        Ask questions about the locations in this collection
      </p>
      <div className="flex flex-col gap-2 w-full max-w-[220px]">
        {SUGGESTED_QUESTIONS.map((q) => (
          <button
            key={q}
            onClick={() => onSendMessage(q)}
            className="text-xs text-left px-3 py-2 rounded-md border bg-background hover:bg-accent transition-colors"
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
